import script from "./CheckStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckStatus.vue?vue&type=script&setup=true&lang=js"

import "./CheckStatus.vue?vue&type=style&index=0&id=b8b201f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8b201f4"]])

export default __exports__